module.exports = __webpack_public_path__ + "static/media/icon_cancel.9b17e57d.svg";